module.exports = __webpack_public_path__ + "static/img/item_j_apple.3c0d4fb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item_j_apple.png
// module id = HOZj
// module chunks = 1